import {observer} from "mobx-react";
import {useNavigate} from "react-router";
import {Page, PageContentTitle} from "../../ui";
import {PmsPrinterList} from "./PmsPrinterList";

export type PmsTabType = 'jobs'

interface PmsOverviewPageProps {
    tab?: PmsTabType
}

const PmsOverviewPage = observer(function PmsOverviewPage({tab}: PmsOverviewPageProps) {
    const navigate = useNavigate()

    const pageActions = [
        {
            label: 'Neuen Drucker anlegen',
            icon: 'add',
            action: () => {
                navigate(`/pms/create`)
            }
        }
    ]

    return <Page cssSuffix={"user"}
                 breadcrumb={[
                     {
                         link: `/pms`,
                         label: 'Drucker'
                     }
                 ]}
                 actions={pageActions}
    >
        <PageContentTitle>
            <div style={{display: "flex"}}>
                <div style={{paddingRight: '1em'}}>
                    <button className={`button is-rounded is-small is-info ${!tab ? '' : 'is-outlined'}`}
                            onClick={() => {
                                navigate(`/pms`)
                            }}>Drucker
                    </button>
                </div>
            </div>
        </PageContentTitle>

        {!tab && <PmsPrinterList/>}
    </Page>
})

export {
    PmsOverviewPage
}
